"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactVirtualized = require("react-virtualized");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const Z_INDEX_STICKY = 100;
const BORDER = '1px solid rgba(224,224,224,1)';
const WindowScrollerWrapper = (0, _styles.styled)('div')({
  flex: '1 1 auto',
  width: '100%',
  minWidth: 0
});
const StickyContents = (0, _styles.styled)('div', {
  shouldForwardProp: prop => prop !== '$sticky'
})(_ref => {
  let {
    theme,
    $sticky
  } = _ref;
  return _objectSpread({
    backgroundColor: '#FFF',
    borderTop: BORDER,
    padding: theme.spacing(1)
  }, !!$sticky && {
    position: 'fixed',
    zIndex: Z_INDEX_STICKY
  });
});
const HeaderLabel = (0, _styles.styled)('div', {
  shouldForwardProp: prop => prop !== '$pad' && prop !== '$row'
})(_ref2 => {
  let {
    theme,
    $pad,
    $row
  } = _ref2;
  return _objectSpread({
    display: 'flex',
    flexDirection: $row ? 'row' : 'column',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    textAlign: $row ? 'center' : '',
    backgroundColor: theme.palette.table.header.primary.main,
    color: theme.palette.table.header.primary.contrastText,
    borderColor: theme.palette.table.header.primary.main,
    borderBottom: BORDER
  }, !!$pad && {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  });
});
const HeaderAction = (0, _styles.styled)('div', {
  shouldForwardProp: prop => prop !== '$row'
})(_ref3 => {
  let {
    $row
  } = _ref3;
  return _objectSpread({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle'
  }, !!$row && {
    height: '100%'
  });
});
const RowWrapper = (0, _styles.styled)('div', {
  shouldForwardProp: prop => prop !== '$striped' && prop !== '$isEven'
})(_ref4 => {
  let {
    theme,
    $striped,
    $isEven
  } = _ref4;
  return _objectSpread({
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    borderBottom: BORDER,
    padding: 0,
    alignItems: 'center'
  }, !!$striped && !!$isEven && {
    background: theme.palette.table.body.secondary.main
  });
});
const ColumnInner = (0, _styles.styled)('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  justifyContent: 'center'
}));
const ActionsCellContainer = (0, _styles.styled)('div')(_ref5 => {
  let {
    theme
  } = _ref5;
  return {
    justifyContent: 'space-around',
    display: 'flex',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    alignItems: 'center'
  };
});
const CellPadding = (0, _styles.styled)('div')(_ref6 => {
  let {
    theme
  } = _ref6;
  return {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  };
});
const COLUMN_DATAKEY_ACTIONS = 'actions';
class BlankComponent extends _react.default.Component {
  componentDidMount() {
    if (typeof this.props.didMount === 'function') {
      this.props.didMount();
    }
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
}

/**
 * ウィンドウスクローラーテーブル部品
 * @prop {array} columns - カラム情報
 * @prop {string} columns.dataKey - データキー(rowDataの属性名と一致させる)<br/>
 *  'actions'を指定した列はボタン表示列として幅が固定化される
 * @prop {node} columns.label - ヘッダに表示するラベル
 * @prop {number} columns.width - 列幅の割合（描画時のwidthはウィンドウサイズに応じて自動計算される）
 * @prop {array|object} rowData - 一覧に表示するデータ(objectで渡す場合rowGetter必須)
 * @prop {func} createRow - データからデータキーを属性名とするコンポーネントオブジェクトを作成する<br/>
 *  シグネチャ:(rowData[index]:object): object{[データキー]:コンポーネント,...}
 * @prop {bool} [putTypography] - カラム描画時にTypographyコンポーネントを追加する時に指定する
 * @prop {bool} [columnPadding] - カラムの左右にpadding spaceを付ける時に指定する
 * @prop {bool} [striped] - 一覧表示を偶数行と奇数行で色分けするときに指定する
 * @prop {node} [stickyContents] - 一覧ヘッダー上部に固定表示するコンテンツがあれば指定する
 * @prop {number} [headerHeight] - ヘッダの高さ（デフォルト：40）
 * @prop {object} [scrollTop] - スクロール位置
 * @prop {number} [scrollTop.index] - スクロール位置(行のindex)
 * @prop {number} [scrollTop.scrollY] - スクロール位置(window.scrollY)
 * @prop {bool} [scrollTop.noSticky] - スクロール位置保持時ヘッダ固定されていなかった場合true
 * @prop {func} [onScroll] - スクロール時のイベント <br/>
 *　シグネチャ:( {index:number,scrollY:number,noSticky:bool }): void
 * @prop {any} [scrollCustomElement] - DOM要素内でスクロールさせるときに指定する
 * @prop {number} [customActionWidth] -一覧内に表示するボタン領域の横幅
 * @prop {func} [getRowData] - 一覧に表示するデータの配列を取得する<br/>
 *  シグネチャ:(rowData:object|array): array
 * @prop {bool} isNewWindow - 別ウィンドウ等でヘッダーを必要としない画面の場合trueを指定する（headerBarHeightを0にする）
 * @prop {bool} [reload] -検索ボタン押下以外で一覧の内容を変更する場合true
 */
class WindowScrollerTable extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "_cache", new _reactVirtualized.CellMeasurerCache({
      fixedWidth: true,
      fixedHeight: false,
      defaultHeight: 40,
      minHeight: 40
    }));
    _defineProperty(this, "_lastRenderedWidth", 0);
    _defineProperty(this, "_init", false);
    _defineProperty(this, "blankComponentDidMount", () => {
      this.setState({
        rowDataChanging: false
      });
    });
    _defineProperty(this, "_setRef", windowScroller => {
      this._windowScroller = windowScroller;
    });
    _defineProperty(this, "_onRowsRendered", _ref7 => {
      let {
        stopIndex
      } = _ref7;
      this.setState({
        stopIndex
      });
    });
    _defineProperty(this, "_headerRowRenderer", _ref8 => {
      let {
        className,
        columns,
        style
      } = _ref8;
      const {
        stickyContents
      } = this.props;
      let stickyHeight = 0;
      if (stickyContents) {
        stickyHeight = this.stickyRef.current ? this.stickyRef.current.getBoundingClientRect().height : 0;
      }
      const top = this._headerBarHeight + stickyHeight;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className,
        style: _objectSpread(_objectSpread({}, style), {}, {
          display: 'flex'
        }, this.state.sticky ? {
          position: 'fixed',
          top,
          zIndex: Z_INDEX_STICKY
        } : {})
      }, columns);
    });
    _defineProperty(this, "_headerLabelRenderer", (dataKey, label, direction) => {
      const {
        putTypography,
        actionWidth,
        columnPadding
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(HeaderLabel, {
        $pad: columnPadding,
        $row: direction === 'row'
      }, dataKey === COLUMN_DATAKEY_ACTIONS && Array.isArray(label) ? label.map((item, index) => /*#__PURE__*/_react.default.createElement(_Typography.default, {
        component: "div",
        key: 'actionsHeader_' + index,
        color: "inherit",
        variant: "body2",
        style: {
          width: actionWidth
        }
      }, /*#__PURE__*/_react.default.createElement(HeaderAction, {
        $row: direction === 'row'
      }, item))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, putTypography ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
        component: "div",
        color: "inherit",
        variant: "body2"
      }, label) : label));
    });
    _defineProperty(this, "_columnCellRenderer", _ref9 => {
      let {
        dataKey,
        parent,
        rowIndex,
        columnIndex
      } = _ref9;
      const {
        createRow,
        putTypography,
        columnPadding
      } = this.props;
      const procRowData = this.state.procRowData ? this.state.procRowData : this.props.rowData;
      const row = createRow(procRowData[rowIndex], rowIndex)[dataKey];
      return /*#__PURE__*/_react.default.createElement(_reactVirtualized.CellMeasurer, {
        cache: this._cache,
        columnIndex: columnIndex,
        key: dataKey,
        parent: parent,
        rowIndex: rowIndex
      }, dataKey === COLUMN_DATAKEY_ACTIONS ? this._actionsColumnRenderer(row) : /*#__PURE__*/_react.default.createElement(ColumnInner, null, columnPadding ? /*#__PURE__*/_react.default.createElement(CellPadding, null, putTypography ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
        component: "div",
        variant: "body2"
      }, row) : row) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, putTypography ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
        component: "div",
        variant: "body2"
      }, row) : row)));
    });
    _defineProperty(this, "_actionsColumnRenderer", items => {
      var _columns$find;
      const {
        columns
      } = this.props;
      const direction = (_columns$find = columns.find(e => e.dataKey === COLUMN_DATAKEY_ACTIONS)) === null || _columns$find === void 0 ? void 0 : _columns$find.direction;
      return /*#__PURE__*/_react.default.createElement(ActionsCellContainer, {
        style: {
          flexDirection: direction === 'row' ? 'row' : direction
        }
      }, Array.isArray(items) && items.map((item, index) => /*#__PURE__*/_react.default.createElement("div", {
        key: 'actionsItem_' + index
      }, item)));
    });
    _defineProperty(this, "_rowGetter", _ref0 => {
      let {
        index
      } = _ref0;
      const procRowData = this.state.procRowData ? this.state.procRowData : this.props.rowData;
      return procRowData[index];
    });
    _defineProperty(this, "_getColumnWidth", (dataKey, rowWidth, colWidth) => {
      const {
        columns,
        columnPadding,
        actionWidth
      } = this.props;
      let actionsColumnCount = 0;
      let colWidthTotal = 0;
      columns.forEach(item => {
        if (item.dataKey === COLUMN_DATAKEY_ACTIONS) {
          actionsColumnCount = item.direction === 'row' ? Array.isArray(item.label) ? item.label.length : 1 : 1;
        } else {
          if (typeof item.width === 'number') {
            colWidthTotal += item.width;
          }
        }
      });
      const actionsWidth = actionsColumnCount ? actionsColumnCount * actionWidth + (columnPadding ? 8 * 2 : 0) : 0;
      if (dataKey === COLUMN_DATAKEY_ACTIONS) {
        return actionsWidth;
      }
      if (!colWidthTotal || colWidthTotal <= 0) {
        return rowWidth - actionsWidth;
      }
      const cw = typeof colWidth === 'number' ? colWidth : 0;
      return (rowWidth - actionsWidth) * (cw / colWidthTotal);
    });
    _defineProperty(this, "_rowRenderer", _ref1 => {
      let {
        index,
        key,
        style,
        columns
      } = _ref1;
      const {
        striped
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(RowWrapper, {
        key: key,
        style: style,
        $striped: striped,
        $isEven: striped && index % 2 !== 0
      }, columns);
    });
    this._headerBarHeight = props.isNewWindow ? 0 : 50;
    this.state = {
      sticky: false,
      scrollTop: undefined,
      stopIndex: 0,
      scrollIndex: props.scrollTop ? props.scrollTop.index : undefined,
      rowDataChanging: false,
      procRowData: typeof props.getRowData === 'function' ? props.getRowData(props.rowData) : undefined
    };
    this.stickyRef = /*#__PURE__*/_react.default.createRef();
  }
  componentDidMount() {
    this._init = true;
  }
  componentDidUpdate(prevProps) {
    if (!this.props.reload && !prevProps.reload && _lodash.default.differenceWith(prevProps.rowData, this.props.rowData).length) {
      this.setState({
        rowDataChanging: true,
        procRowData: typeof this.props.getRowData === 'function' ? this.props.getRowData(this.props.rowData) : undefined
      });
      this._cache.clearAll();
    } else if (prevProps.getRowData !== this.props.getRowData) {
      this.setState({
        procRowData: this.props.getRowData(this.props.rowData)
      });
      this._cache.clearAll();
    }
  }
  componentWillUnmount() {
    if (this.props.onScroll) {
      const noSticky = !this.state.sticky;
      const index = noSticky ? undefined : this.state.stopIndex;
      this.props.onScroll({
        index,
        scrollY: window.scrollY,
        noSticky
      });
    }
  }
  render() {
    const {
      stickyContents,
      columns,
      scrollCustomElement,
      headerHeight
    } = this.props;
    const procRowData = this.state.procRowData ? this.state.procRowData : this.props.rowData;
    if (scrollCustomElement) {
      this._headerBarHeight = scrollCustomElement.getBoundingClientRect().y;
    }
    const onScroll = _ref10 => {
      let {
        scrollTop
      } = _ref10;
      let newState = {
        scrollTop
      };
      const headerContentsHeight = this._headerBarHeight + headerHeight + (this.stickyRef.current ? this.stickyRef.current.getBoundingClientRect().height : 0);
      if (!this.state.sticky && scrollTop > headerContentsHeight) {
        //ヘッダ分以上スクロールした時ヘッダを固定
        this.setState({
          sticky: true
        });
        if (!this._init) {
          newState.scrollTop = newState.scrollTop - headerContentsHeight;
        }
        if (this._windowScroller) {
          this._windowScroller.updatePosition();
        }
      } else if (this.state.sticky && scrollTop === 0) {
        //ヘッダ固定状態でスクロール位置が0になったときヘッダ固定解除
        this.setState({
          sticky: false
        });
      }
      if (this._init) {
        newState.scrollIndex = undefined;
      }
      this.setState(newState);
    };
    if (this.state.rowDataChanging) {
      return /*#__PURE__*/_react.default.createElement(BlankComponent, {
        didMount: this.blankComponentDidMount
      });
    }
    return /*#__PURE__*/_react.default.createElement(_reactVirtualized.WindowScroller, {
      ref: this._setRef,
      onScroll: onScroll,
      scrollElement: scrollCustomElement ? scrollCustomElement : window
    }, _ref11 => {
      let {
        height,
        onChildScroll
      } = _ref11;
      return /*#__PURE__*/_react.default.createElement(WindowScrollerWrapper, null, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          width: '100%',
          minWidth: 0
        }
      }, /*#__PURE__*/_react.default.createElement(_reactVirtualized.AutoSizer, {
        disableHeight: true,
        onResize: _ref12 => {
          let {
            width
          } = _ref12;
          if (this._lastRenderedWidth !== width) {
            this._lastRenderedWidth = width;
            this._cache.clearAll();
          }
        }
      }, _ref13 => {
        let {
          width
        } = _ref13;
        return /*#__PURE__*/_react.default.createElement("div", {
          style: {
            width: '100%',
            minWidth: 0
          }
        }, stickyContents && /*#__PURE__*/_react.default.createElement(StickyContents, {
          $sticky: this.state.sticky,
          style: {
            top: this._headerBarHeight,
            width
          },
          ref: this.stickyRef
        }, stickyContents), /*#__PURE__*/_react.default.createElement(_reactVirtualized.Table, {
          ref: el => {
            window.listEl = el;
            this._table = el;
          },
          autoHeight: true,
          headerHeight: headerHeight,
          height: height ? height + 50 : 0,
          overscanRowCount: 10,
          rowCount: procRowData.length,
          rowGetter: this._rowGetter,
          rowHeight: this._cache.rowHeight,
          width: width,
          onScroll: scrollInfo => {
            onChildScroll(scrollInfo);
          },
          scrollTop: this.state.scrollTop,
          scrollToIndex: this.state.scrollIndex,
          onRowsRendered: this._onRowsRendered,
          headerRowRenderer: this._headerRowRenderer,
          rowRenderer: this._rowRenderer
        }, columns.map((_ref14, index) => {
          let {
            dataKey,
            label
          } = _ref14;
          const colWidth = this._getColumnWidth(dataKey, width, columns[index].width);
          return /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
            key: ['TableColumn', index].join('_'),
            dataKey: dataKey,
            label: this._headerLabelRenderer(dataKey, label, columns[index].direction),
            width: colWidth,
            minWidth: colWidth,
            cellRenderer: this._columnCellRenderer
          });
        })));
      })));
    });
  }
}
WindowScrollerTable.defaultProps = {
  headerHeight: 40,
  actionWidth: 64
};
WindowScrollerTable.propTypes = {
  columns: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.node.isRequired,
    dataKey: _propTypes.default.string.isRequired,
    width: _propTypes.default.number
  })).isRequired,
  rowData: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object]).isRequired,
  createRow: _propTypes.default.func.isRequired,
  putTypography: _propTypes.default.bool,
  columnPadding: _propTypes.default.bool,
  striped: _propTypes.default.bool,
  stickyContents: _propTypes.default.node,
  headerHeight: _propTypes.default.number,
  scrollTop: _propTypes.default.shape({
    index: _propTypes.default.number,
    scrollY: _propTypes.default.number,
    noSticky: _propTypes.default.bool
  }),
  onScroll: _propTypes.default.func,
  scrollCustomElement: _propTypes.default.any,
  actionWidth: _propTypes.default.number,
  getRowData: _propTypes.default.func,
  isNewWindow: _propTypes.default.bool,
  reload: _propTypes.default.bool
};
var _default = exports.default = WindowScrollerTable;